export default __webpack_public_path__ + "static/media/minus-icon.e699542a.svg";